import React from "react";
import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useTheme } from "@emotion/react";

const MultiSelectField = ({
  label,
  name,
  value = [],
  handleChange = () => {},
  options = [],
  getOptionLabel = (opt) => opt,
  getOptionValue = (opt) => opt,
  isError = false,
  errorText = "",
  renderValue,
  borderRadius,
  ...rest
}) => {
  const theme = useTheme();

  const onChangeHandler = (event) => {
    const {
      target: { value: selectedIds },
    } = event;

    const selectedObjects = options.filter((opt) =>
      selectedIds.includes(getOptionValue(opt))
    );

    handleChange(selectedObjects);
  };

  const selectedIds = value.map((val) => getOptionValue(val));

  const appliedBorderRadius = borderRadius || "4px";

  return (
    <FormControl fullWidth size="small" error={isError}>
      <InputLabel
        id={`${name}-label`}
        sx={{ color: theme.palette.text.primary }}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={`${name}-select`}
        multiple
        value={selectedIds}
        onChange={onChangeHandler}
        label={label}
        renderValue={
          renderValue ||
          ((selected) => {
            const selectedLabels = value.map((val) => getOptionLabel(val));
            return selectedLabels.length
              ? `${selectedLabels[0]}${
                  selectedLabels.length > 1
                    ? `, +${selectedLabels.length - 1}`
                    : ""
                }`
              : `Select ${label}`;
          })
        }
        sx={{
          borderRadius: appliedBorderRadius,
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: appliedBorderRadius,
          },
        }}
        {...rest}
      >
        {options.map((option) => {
          const val = getOptionValue(option);
          return (
            <MenuItem key={val} value={val}>
              <Checkbox checked={selectedIds.includes(val)} />
              {getOptionLabel(option)}
            </MenuItem>
          );
        })}
      </Select>
      {isError && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

export default MultiSelectField;
